/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link,withRouter } from "react-router-dom";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
  Button,
  UncontrolledCollapse,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";
import { logoutUser } from '../../actions/auth';
import { connect } from 'react-redux';
import argon_react_white from 'assets/img/brand/argon_react_white.png';
import argon_react_white_png from 'assets/img/brand/argon-react-white.png';
import { Tooltip } from 'reactstrap';

class DemoNavbar extends React.Component {
  componentDidMount() {
    let headroom = new Headroom(document.getElementById("navbar-main"));
    // initialise
    const {pathname} = this.props.location;
    console.log("pathname", pathname);
    headroom.init();
  }
  state = {
    collapseClasses: "",
    collapseOpen: false,
    tooltipOpen:false,
  };

  toggleToolTip = () => this.setState({tooltipOpen:!this.state.tooltipOpen});

  onExiting = () => {
    this.setState({
      collapseClasses: "collapsing-out"
    });
  };

  onExited = () => {
    this.setState({
      collapseClasses: ""
    });
  };
  logoutUser=()=>{
    this.props.logoutUser();
  }
  render() {
    
    const token = localStorage.getItem('token_bigbrand');    
    const user = localStorage.getItem('user_bigbrand');
    var firstName = "";
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      firstName = userinfo['firstname']
      role = userinfo['role']
      console.log("userinfo",userinfo)
    }
    console.log("token_bigbrand", token);
    const {pathname} = this.props.location;
    return (
      <>
        <header className="header-global">
          <Navbar
            className="navbar-main navbar-transparent navbar-light headroom"
            expand="lg"
            id="navbar-main"
          >
            {/* <Container> */}
              <NavbarBrand className="" to={role=="admin"?"/admin/requests":"/myorders"} tag={Link}>
                <img
                  alt="..."
                  src={argon_react_white}
                />
              </NavbarBrand>
              {token&&
              <button className="navbar-toggler" id="navbar_global">
                <span className="navbar-toggler-icon" />
              </button>
              }
              <UncontrolledCollapse
                toggler="#navbar_global"
                navbar
                className={'headermenu '+ this.state.collapseClasses}
                onExiting={this.onExiting}
                onExited={this.onExited}
               
              >
                <div className="navbar-collapse-header">
                  <Row>
                    <Col className="collapse-brand" xs="6">
                      <Link to={role=="admin"?"/admin/requests":"/myorders"}>
                        <img
                          alt="..."
                          src={argon_react_white_png}
                        />
                      </Link>
                    </Col>
                    <Col className="collapse-close" xs="6">
                      <button className="navbar-toggler" id="navbar_global">
                        <span />
                        <span />
                      </button>
                    </Col>
                  </Row>
                </div>
                {token&&
                <>
                <Nav className="navbar-nav-hover align-items-lg-center ml-lg-auto " navbar>
                  <NavItem>
                    <NavLink
                      className={ 'nav-link-icon '+ (pathname.includes("/hello")?"active":"")}
                      to="#"
                      tag={Link}
                      style={{cursor:'default'}}
                    >
                    {/* <i className="ni ni-ui-04 d-lg-none mr-1" /> */}
                    <span className="nav-link-inner--text" style={{textTransform:'capitalize'}}>HELLO {firstName?firstName.toUpperCase():""}!</span>
                    </NavLink>
                  </NavItem>
                </Nav>
                {/* <Nav className="navbar-nav-hover align-items-lg-center " navbar>
                  <NavItem>
                    <NavLink
                      className={ 'nav-link-icon '+ (pathname.includes("/producta")?"active":"")}
                      to="/products"                    
                      tag={Link}
                    >
                    <span className="nav-link-inner--text">PRODUCTS</span>
                    </NavLink>
                  </NavItem>
                </Nav> */}
                {role!="admin" &&
                <>
                  {/* <Nav className="navbar-nav-hover align-items-lg-center " navbar>
                    <NavItem>
                      <NavLink
                        className={ 'nav-link-icon '+ (pathname.includes("/myaccount")?"active":"")}
                        to="/myaccount"
                        tag={Link}
                      >
                      <span className="nav-link-inner--text">ACCOUNT</span>
                      </NavLink>
                    </NavItem>
                  </Nav> */}
                  <Nav className="navbar-nav-hover align-items-lg-center " navbar>
                    <NavItem>
                      <NavLink
                        className={ 'nav-link-icon '+ (pathname.includes("/howtoorder")?"active":"")}
                        to="/howtoorder"
                        tag={Link}
                      >
                      {/* <i className="ni ni-ui-04 d-lg-none mr-1" /> */}
                      <span className="nav-link-inner--text">HOW TO ORDER</span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Nav className="navbar-nav-hover align-items-lg-center " navbar>
                    <NavItem>
                      <NavLink
                        className={ 'nav-link-icon '+ (pathname.includes("/myorders")?"active":"")}
                        to="/myorders"
                        tag={Link}
                      >
                      {/* <i className="ni ni-ui-04 d-lg-none mr-1" /> */}
                      <span className="nav-link-inner--text">MY ORDERS</span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                </>
                }
                {role=="admin" &&
                <>         
                {/* <Nav className="navbar-nav-hover align-items-lg-center " navbar>
                  <NavItem>
                    <NavLink
                      className={ 'nav-link-icon '+ (pathname.includes("/quote_manager")?"active":"")}
                      to="/admin/quote_manager"
                      // 
                      tag={Link}
                    >
                    <span className="nav-link-inner--text">QUOTE MANAGER</span>
                    </NavLink>
                  </NavItem>
                </Nav>        */}

                {/* <Nav className="navbar-nav-hover align-items-lg-center " navbar>
                  <NavItem>
                    <NavLink
                      className={ 'nav-link-icon '+ (pathname.includes("/all_accounts")?"active":"")}
                      to="/admin/all_accounts"
                      // 
                      tag={Link}
                    >
                    <span className="nav-link-inner--text">ALL ACCOUNTS</span>
                    </NavLink>
                  </NavItem>
                </Nav> */}
                <Nav className="navbar-nav-hover align-items-lg-center " navbar>
                  <NavItem>
                    <NavLink
                      className={ 'nav-link-icon '+ (pathname.includes("/requests")?"active":"")}
                      to="/admin/requests"
                      // 
                      tag={Link}
                    >
                    {/* <i className="ni ni-ui-04 d-lg-none mr-1" /> */}
                    <span className="nav-link-inner--text">QUOTES</span>
                    </NavLink>
                  </NavItem>
                </Nav>
                <Nav className="navbar-nav-hover align-items-lg-center " navbar>
                  <NavItem>
                    <NavLink
                      className={ 'nav-link-icon '+ (pathname.includes("/myorders")?"active":"")}
                      to="/admin/myorders"
                      // 
                      tag={Link}
                    >
                    {/* <i className="ni ni-ui-04 d-lg-none mr-1" /> */}
                    <span className="nav-link-inner--text">CLIENTS</span>
                    </NavLink>
                  </NavItem>
                </Nav>
                <Nav className="navbar-nav-hover align-items-lg-center " navbar>
                  <NavItem>
                    <NavLink
                      className={ 'nav-link-icon '+ (pathname.includes("/uploadproduct")?"active":"")}
                      to="/admin/uploadproduct"
                      // 
                      tag={Link}
                    >
                    {/* <i className="ni ni-ui-04 d-lg-none mr-1" /> */}
                    <span className="nav-link-inner--text">DATA</span>
                    </NavLink>
                  </NavItem>
                </Nav>
                </>
                }                
                <Nav className="navbar-nav-hover align-items-lg-center " navbar id="menu-item-catalogues">
                  <NavItem>
                    <a
                      className={ 'nav-link nav-link-icon '+ (pathname.includes("/catalogues")?"active":"")}
                      href="https://bigbranding.com.au/catalogues"
                      // 
                      target="_blank"
                      tag={Link}
                      
                    >
                    {/* <i className="ni ni-ui-04 d-lg-none mr-1" /> */}
                    <span className="nav-link-inner--text">CATALOGUES</span>
                    </a>
                  </NavItem>
                </Nav>
                  
                <Tooltip placement="bottom" isOpen={this.state.tooltipOpen} className="text-left" target="menu-item-catalogues" toggle={this.toggleToolTip}>
                  In the catalogues section, you can browse through your favorite catalogues and make your product selections. 
                  <br/><br/>
                  To help make the quote process smoother, we recommend identifying the SKU code for your preferred products before proceeding. 
                  Additionally, to keep costs and lead times to a minimum, we suggest selecting your garments from as few catalogues as possible. 
                  <br/><br/>
                  If you need help or have any questions, our team is available to provide advice and assistance.
                </Tooltip>
                
                {role=="admin" &&
                <Nav className="navbar-nav-hover align-items-lg-center " navbar id="menu-item-setting">
                  <NavItem>
                    <NavLink
                      className={ 'nav-link-icon '+ (pathname.includes("/setting")?"active":"")}
                      to="/admin/setting"
                      // 
                      tag={Link}
                      
                    >
                    {/* <i className="ni ni-ui-04 d-lg-none mr-1" /> */}
                    <span className="nav-link-inner--text">ACCOUNT</span>
                    </NavLink>
                  </NavItem>
                </Nav>
                }
                <Nav className="navbar-nav-hover align-items-lg-center  no-border" navbar>
                  <NavItem>
                    <NavLink
                      className={ 'nav-link-icon'}
                      to="#"
                      onClick={()=>this.logoutUser()}
                      // tag={Link}
                      style={{cursor:'pointer'}}
                    >
                    {/* <i className="ni ni-ui-04 d-lg-none mr-1" /> */}
                    <span className="nav-link-inner--text">LOG OUT</span>
                    </NavLink>
                  </NavItem>
                </Nav>
                </>
                }
                {/* <Nav className="align-items-lg-center ml-lg-auto" navbar> */}
                  {/* <NavItem>
                    <NavLink
                      className="nav-link-icon nav-icon"
                      to="#"
                      id="tooltip333589074"
                      
                      tag={Link}
                    >
                      <i className="fa fa-search" />
                      <span className="nav-link-inner--text d-lg-none ml-2">
                        Search
                      </span>
                    </NavLink>
                  </NavItem>               */}
                {/* </Nav> */}
              </UncontrolledCollapse>
            {/* </Container> */}
          </Navbar>
        </header>
      </>
    );
  }
}


const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    logoutUser: ()=>dispatch(logoutUser()),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(withRouter(props => <DemoNavbar {...props}/>));

// export default withRouter(props => <DemoNavbar {...props}/>);
